import React from 'react';

import Placeholder from 'components/consumer/Placeholder';
import PDPInfoTable from './PDPInfoTable';

// One shipping-box row, sized like the live heading and table. Shown until
// box dimensions resolve so the section below does not jump up and back.
const PDPShippingDimensionsPlaceholder = () => (
  <div
    className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14"
    data-xc="PDPShippingDimensionsPlaceholder"
  >
    <div className="max-w-[480px] mx-auto">
      <h2 className="text-xl font-bold text-gray">
        <Placeholder
          loading
          type="rect"
          style={{ height: '22px', width: '220px' }}
        />
      </h2>
      <PDPInfoTable loading placeholderRowCount={1} matchContentSize />
    </div>
  </div>
);

export default PDPShippingDimensionsPlaceholder;
